import React, { Component } from 'react';
import FX from './functions/functions';
import './css/Confirm.css';
import { Scrollbars } from 'react-custom-scrollbars';
//import FX from './functions/functions';

class Confirm extends Component {
  render(){
    var buttons;
    if (this.props.alert){
      buttons = (
        <div className="buttons">
          <button>OK</button>
        </div>
      )
    }
    else {
      buttons = (
        <div className="buttons">
          <button>Cancel</button>
          <button>OK</button>
        </div>
      )
    }
    var fs = "confirmMessage ";
    if (this.props.fs){
      fs += 'fs';
    }
    return (<div className="confirmShade" onClick={this.props.close} id="Confirm">
              <div onClick={(e)=>{e.stopPropagation();}}  className={fs} >
                  <div className="body" style={{ position: 'relative'}}>
                      {this.props.children}
                  </div>
                  {buttons}
              </div>
          </div>);
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/Confirm.js